export default __webpack_public_path__ + "static/media/ag-logo.e0b617b7.png";